import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row gx-0 p-4 px-lg-5 justify-content-center" }
const _hoisted_2 = { class: "col-12 col-md-8" }
const _hoisted_3 = { class: "row py-3" }
const _hoisted_4 = { class: "col-10 h1 align-self-center" }
const _hoisted_5 = { class: "text-uppercase fw-bold" }
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = { class: "avatar-circle" }
const _hoisted_8 = { class: "nombreCompleto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-md-8"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 h2 text-uppercase fw-bold" }, "Datos personales", -1)
const _hoisted_13 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Nombre:", -1)
const _hoisted_15 = { class: "h4" }
const _hoisted_16 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Apellido:", -1)
const _hoisted_18 = { class: "h4" }
const _hoisted_19 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Email:", -1)
const _hoisted_21 = { class: "h4" }
const _hoisted_22 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Documento:", -1)
const _hoisted_24 = { class: "h4" }
const _hoisted_25 = {
  key: 0,
  class: "col-12 col-md-6 my-1 p-2"
}
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "h4 mt-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_29 = { class: "col-12 col-md-8" }
const _hoisted_30 = { class: "row py-3" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_33 = { class: "col-12 col-md-8" }
const _hoisted_34 = { class: "row py-3" }
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)

import FormVehiculosAsociados from '@/components/FormVehiculosAsociados.vue'
import TheBeneficiosRedimidos from '@/components/rebranding/TheBeneficiosRedimidos.vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'MiCuenta',
  setup(__props) {

const { state } = useStore<VuexStore>(key)

const iniciales = (nombreCompleto: string) =>
  nombreCompleto
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()

const nombreclub = (eventoId: number) => {
  switch (eventoId) {
    case 9:
      return 'PEUGEOT LIONS'
    case 11:
      return 'THE SCORPIONSHIPS'
    case 12:
      return 'ONLY YOU'
    case 15:
      return 'RAM SOCIETY'
    case 14:
      return 'JEEP WAVE'
    case 16:
      return 'CITROËN CLUB'
  }
  return
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createTextVNode(" Hola, "),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(state).authUser?.nombre) + " " + _toDisplayString(_unref(state).authUser?.apellido), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(iniciales(
                  `${_unref(state).authUser?.nombre} ${_unref(state).authUser?.apellido}`
                )), 1)
          ])
        ]),
        _hoisted_9
      ])
    ]),
    (_unref(state).authUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(state).authUser.nombre), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(state).authUser.apellido), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(state).authUser.email), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(state).authUser.documento ?? '--'), 1)
            ]),
            (_unref(state).evento?.eventoId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, " Miembro de " + _toDisplayString(nombreclub(_unref(state).evento.eventoId)) + ": ", 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(state).authUser?.miembroDesde ? _unref(dayjs)(_unref(state).authUser.miembroDesde).format('DD/MM/YYYY') : 'PENDIENTE DE VALIDACIÓN'), 1)
                ]))
              : _createCommentVNode("", true),
            _hoisted_28
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(FormVehiculosAsociados)
        ]),
        _hoisted_32
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(TheBeneficiosRedimidos)
        ]),
        _hoisted_36
      ])
    ])
  ]))
}
}

})